// pages/NhaVuon/NhaONhieuTang/index.tsx
// Trang Nhà Vườn Nhiều Tầng — CLEAN

import { useState } from 'react'
import { PageHero, ProjectGrid, CtaSection, Pagination } from '../../../../components'
import { useProjects } from '../../../../features/projects/hooks/useProjects'
import { nhaVuonNhieuTangProjects } from '../../../../data/nhaVuonProjects'
import useDocumentTitle from '../../../../hooks/useDocumentTitle'
import './NhaONhieuTang.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Công trình thiết kế', path: '/cong-trinh-thiet-ke' },
  { label: 'Nhà vườn', path: '/nha-vuon' },
  { label: 'Nhà nhiều tầng' },
]

const NhaVuonNhieuTangPage = () => {
  useDocumentTitle('Nhà Vườn Nhiều Tầng - MAXCONST')
  
  useState(() => {
    try {
      sessionStorage.setItem('lastVisitedList', '/nha-vuon/nhieu-tang')
      sessionStorage.setItem('lastVisitedListName', 'Nhà vườn nhiều tầng')
    } catch (e) {
      // ignore
    }
  })

  const {
    currentProjects,
    loading,
    error,
    currentPage,
    totalPages,
    totalCount,
    startIndex,
    endIndex,
    setCurrentPage,
    goToNextPage,
    goToPrevPage,
    getPageNumbers,
  } = useProjects({
    category: 'nhieu-tang',
    pages: 10,
  })

  return (
    <div className="nha-vuon-nhieu-tang-page">
      {/* Hero */}
      <PageHero
        tag="Thiết Kế Nhà Vườn"
        title="Nhà Vườn Nhiều Tầng"
        description="Những mẫu nhà vườn nhiều tầng ấn tượng, tối ưu không gian sống cho gia đình đông thành viên"
        breadcrumbs={BREADCRUMBS}
        stats={
          totalCount > 0
            ? [
                { number: `${totalCount}+`, label: 'Mẫu thiết kế' },
                { number: '3+', label: 'Tầng trở lên' },
                { number: '100%', label: 'Thiết kế riêng biệt' },
              ]
            : undefined
        }
      />

      {/* Content */}
      <div className="container section">
        <ProjectGrid
          projects={currentProjects}
          loading={loading}
          error={error}
        />

        {!loading && !error && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            startIndex={startIndex}
            endIndex={endIndex}
            getPageNumbers={getPageNumbers}
            onPageChange={setCurrentPage}
            onPrev={goToPrevPage}
            onNext={goToNextPage}
          />
        )}

        <CtaSection
          title="Thiết Kế Nhà Nhiều Tầng Theo Yêu Cầu"
          titleHighlight="Theo Yêu Cầu"
          description="Đội ngũ kiến trúc sư giàu kinh nghiệm sẵn sàng tư vấn và thiết kế theo đặc thù từng công trình"
        />
      </div>
    </div>
  )
}

export default NhaVuonNhieuTangPage
